import { render, staticRenderFns } from "./SickKepuKangfuyixueke.vue?vue&type=template&id=72bfbe17&scoped=true"
import script from "./SickKepuKangfuyixueke.vue?vue&type=script&lang=js"
export * from "./SickKepuKangfuyixueke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bfbe17",
  null
  
)

export default component.exports